import script from "./CompaniesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompaniesList.vue?vue&type=script&lang=ts&setup=true"

import "./CompaniesList.vue?vue&type=style&index=0&id=de39c602&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de39c602"]])

export default __exports__